import { render, staticRenderFns } from "./DsSalesRankModule.vue?vue&type=template&id=5dab6b3c&scoped=true"
import script from "./DsSalesRankModule.vue?vue&type=script&lang=js"
export * from "./DsSalesRankModule.vue?vue&type=script&lang=js"
import style0 from "./DsSalesRankModule.vue?vue&type=style&index=0&id=5dab6b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab6b3c",
  null
  
)

export default component.exports